import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';
import { Translator } from '../translator.interface';
import { Account, AccountBackend } from './accounts.interfaces';

export class AccountsTranslator implements Translator<AccountBackend, Account> {
  translateOneToBackendModel(resource: Account): AccountBackend {
    // TODO: validate model
    return {
      name: resource.name,
      modelType: resource.modelType,
      type: resource.type,
      // eslint-disable-next-line no-underscore-dangle
      _deleted: resource._deleted,
      lastChangedAt: resource.lastChangedAt,
      version: resource.version,
      createdAt: resource.createdAt,
      email: resource.email,
      id: resource.id,
      notes: resource.notes,
      phone: resource.phone,
      updatedAt: resource.updatedAt,
    };
  }

  translatePartialToBackendModel(
    resource: Account,
  ): Partial<AccountBackend> & Required<DataStoreModel> {
    const allProps = this.translateOneToBackendModel(resource);
    const partialProps: Partial<AccountBackend> & Required<DataStoreModel> = {
      id: resource.id,
      modelType: ModelTypes.Account,
    };
    Object.keys(resource).forEach((key) => {
      partialProps[key] = allProps[key];
    });
    return partialProps;
  }

  translate(resources: AccountBackend[]): Account[] {
    // TODO: validate model
    return resources.map((resource) => {
      return this.translateOne(resource);
    });
  }
  translateOne(resource: AccountBackend): Account {
    return {
      name: resource.name,
      modelType: resource.modelType,
      type: resource.type,
      // eslint-disable-next-line no-underscore-dangle
      _deleted: resource._deleted,
      lastChangedAt: resource.lastChangedAt,
      version: resource.version,
      createdAt: resource.createdAt,
      email: resource.email,
      id: resource.id,
      notes: resource.notes,
      phone: resource.phone,
      updatedAt: resource.updatedAt,
    };
  }
}
